import React, { useState, useEffect, useRef } from "react";
import {
  logo,
  testSheet,
  WhoWeAreImgpowerd,
  Calender,
  grayClock,
  userImage,
  dummyuserImage,
  CameraIcon,
  uploadProfile,
  statTestIcon,
  AlertTriangle,
} from "../../Common/CommonImages";
import LightModeIcon from "@mui/icons-material/LightMode";
import FaceIcon from "@mui/icons-material/Face";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorIcon from "@mui/icons-material/Error";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import PanoramaIcon from "@mui/icons-material/Panorama";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  Checkbox,
  Button,
  Box,
  CircularProgress,
  Typography,
  Tooltip,
  Stack,
  Divider,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  setFullScreen,
  setTestData,
  setAllSelectedAnswers,
  setPreviousSpentTime,
} from "../../store/Test/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import base64 from "base64-js";
import { store } from "../../store/index";
import {
  setCandidateMode,
  setCandidateImage,
  setInviteId,
  setCandidateImageStatus,
  setStartTime,
  setResumeDate,
} from "../../store/Candidate/action";
import { askScreenShare, stopScreenShare } from "../../store/Screen/actions";
import { startCamera, stopCamera } from "../../store/Camera/action";
import {
  BASE_URL,
  handleDynamicRequest,
  handleDynamicRequestHeader,
} from "../../Common/CommonExport";
import { enterFullScreen } from "../../utils/fullscreen";
import Webcam from "react-webcam";
import { parsePhoneNumber } from "react-phone-number-input";
import PoseOverlay from "../../Components/PoseOverlay/PoseOverlay";
import { useLightingDetection } from "../../hooks/useLightingDetection";
import { isMobileDevice } from "../../utils/deviceDetection.util";
import AssessmentHeader from "../../Components/AssessmentHeader";
import { faceDetectionService } from "../../services/faceDetection.service";

const videoConstraints = { width: 1280, height: 720, facingMode: "user" };



// ── AI check icon ─────────────────────────────────────────────────────────────
function AiCheckIcon({ status }) {
  if (status === "success")
    return <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 18 }} />;
  if (status === "error")
    return <ErrorIcon sx={{ color: "#f44336", fontSize: 18 }} />;
  if (status === "warning")
    return <WarningAmberIcon sx={{ color: "#ff9800", fontSize: 18 }} />;
  return <CircularProgress size={14} sx={{ color: "#FF6812" }} />;
}

// ── Main Component ─────────────────────────────────────────────────────────────
function StartTest() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const testName = useSelector((s) => s.testReducer.name);
  const testTime = useSelector((s) => s.testReducer.time);
  const testDate = useSelector((s) => s.testReducer.date);
  const setting = useSelector((s) => s.testReducer.setting);
  const testId = useSelector((s) => s.testReducer.testId);
  const candidateRetake = useSelector((s) => s.candidateReducer.retake);
  const testInstructions = useSelector((s) => s.testReducer.instructions);
  const cameraStarted = useSelector((s) => s.cameraReducer.isCameraOn);
  const webcamStream = useSelector((s) => s.cameraReducer.webcamStream);
  const candidateName = useSelector((s) => s.candidateReducer.name);
  const candidateEmail = useSelector((s) => s.candidateReducer.email);
  const candidateMobile = useSelector((s) => s.candidateReducer.mobile);
  const collegeName = useSelector((s) => s.candidateReducer.collegeName);
  const candidateFields = useSelector((s) => s.candidateReducer.fields);
  const candidateImage = useSelector((s) => s.candidateReducer.image);
  const candidateImageStatus = useSelector((s) => s.candidateReducer.status);
  const screenStream = useSelector((s) => s.screenReducer.screenStream);
  const isScreenShared = useSelector((s) => s.screenReducer.isScreenShared);
  const testSettings = useSelector((s) => s.testReducer.setting);

  const [loading, setLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [timer, setTimer] = useState(3);
  const [ShowTimer, setShowTimer] = useState(false);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [multiScreenChecked, setMultiScreenChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [showError, setShowError] = useState({
    screenShare: false,
    camera: false,
    image: false,
  });
  const [showStartDialog, setShowStartDialog] = useState(false);
  const [showCameraDialog, setShowCameraDialog] = useState(false);

  const webcamRef = useRef(null);
  const faceBoundingBoxRef = useRef(null);
  const stabilityCounterRef = useRef(0);
  const isTimerRunningRef = useRef(false);
  const isValidPoseRef = useRef(false);
  const timerIntervalRef = useRef(null);
  const pendingFinalCheckRef = useRef(false);
  const autoStartAttempts = useRef({ camera: false, screen: false });

  const [aiChecks, setAiChecks] = useState({
    lighting: {
      status: "pending",
      message: "Checking lighting...",
      accuracy: 0,
    },
    face: {
      status: "pending",
      message: "Detecting face...",
      instruction: "Align your face within the guide",
      accuracy: 0,
    },
    eyes: {
      status: "pending",
      message: "Checking eye contact...",
      accuracy: 0,
    },
  });

  const snapshotSetting = setting.find(
    (s) => s.setting === "Take Snapshots via webcam every 30 second",
  );
  const screenSetting = setting.find(
    (s) => s.setting === "Take screen snapshots on tab switch",
  );

  // Skip screen sharing on mobile
  if (isMobileDevice() && screenSetting) {
    screenSetting.active = false;
  }
  const multiScreenSetting = setting.find(
    (s) => s.setting === "Multi Screen Check",
  );
  const hasSystemCheck = testSettings?.some(
    (s) => s.setting === "Restrict peripheral device usage" && s.active,
  );

  useEffect(() => {
    isTimerRunningRef.current = isTimerRunning;
  }, [isTimerRunning]);
  useEffect(() => {
    if (candidateImage) setImageSrc(candidateImage);
  }, [candidateImage]);
  useEffect(() => {
    const snap = testSettings?.find(
      (s) => s.setting === "Take Snapshots via webcam every 30 second",
    );
    if (!snap?.active && cameraStarted) dispatch(stopCamera());
  }, [testSettings, cameraStarted, dispatch]);

  useEffect(() => {
    if (showCameraDialog) {
      setCapturedImage(null);
      setAiChecks({
        lighting: {
          status: "pending",
          message: "Checking lighting...",
          accuracy: 0,
        },
        face: {
          status: "pending",
          message: "Detecting face...",
          instruction: "Align your face within the guide",
          accuracy: 0,
        },
        eyes: {
          status: "pending",
          message: "Checking eye contact...",
          accuracy: 0,
        },
      });
      stabilityCounterRef.current = 0;
    }
  }, [showCameraDialog]);

  useEffect(() => {
    if (!testSettings || testSettings.length === 0) return;
    const snap = testSettings.find(
      (s) => s.setting === "Take Snapshots via webcam every 30 second",
    );
    const screen = testSettings.find(
      (s) => s.setting === "Take screen snapshots on tab switch",
    );
    if (
      snap?.active &&
      !cameraStarted &&
      !webcamStream &&
      !autoStartAttempts.current.camera
    ) {
      autoStartAttempts.current.camera = true;
      dispatch(startCamera());
    }
    if (
      screen?.active &&
      !isScreenShared &&
      !screenStream &&
      !autoStartAttempts.current.screen &&
      !isMobileDevice()
    ) {
      autoStartAttempts.current.screen = true;
      dispatch(askScreenShare()).catch(() => {});
    }
  }, [
    testSettings,
    cameraStarted,
    webcamStream,
    isScreenShared,
    screenStream,
    dispatch,
  ]);

  useEffect(() => {
    const handleBack = () => {
      if (webcamStream?.getTracks)
        webcamStream.getTracks().forEach((t) => t.stop());
    };
    const handleUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("popstate", handleBack);
    window.addEventListener("beforeunload", handleUnload);
    return () => {
      window.removeEventListener("popstate", handleBack);
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [webcamStream]);

  const { lightingResult } = useLightingDetection({
    videoElement: webcamRef.current?.video,
    enabled: !!webcamStream && !capturedImage,
    faceBoundingBoxRef,
  });

  useEffect(() => {
    if (!lightingResult) return;
    if (["good", "excellent", "acceptable"].includes(lightingResult.quality)) {
      setAiChecks((p) => ({
        ...p,
        lighting: {
          status: "success",
          message: "Lighting is good",
          accuracy: lightingResult.luma,
        },
      }));
    } else if (lightingResult.isBlocked) {
      setAiChecks((p) => ({
        ...p,
        lighting: {
          status: "error",
          message: "Too dark or face obscured",
          accuracy: lightingResult.luma,
        },
      }));
    } else {
      setAiChecks((p) => ({
        ...p,
        lighting: {
          status: "warning",
          message: "Poor lighting",
          accuracy: lightingResult.luma,
        },
      }));
    }
  }, [lightingResult]);

  useEffect(() => {
    let animId;
    let lastRun = 0;
    const processFrame = async (ts) => {
      if (!lastRun) lastRun = ts;
      if (ts - lastRun < 500 && !pendingFinalCheckRef.current) {
        animId = requestAnimationFrame(processFrame);
        return;
      }
      lastRun = ts;
      if (
        webcamRef.current?.video &&
        webcamRef.current.video.readyState >= 2 &&
        webcamStream &&
        (!capturedImage || pendingFinalCheckRef.current)
      ) {
        try {
          const res = await faceDetectionService.detectFace(
            webcamRef.current.video,
            ts,
          );
          if (res?.faceLandmarks?.length > 0) {
            const lm = res.faceLandmarks[0];
            const base = lm.map((l) => l.x),
              ys = lm.map((l) => l.y);
            faceBoundingBoxRef.current = {
              x: Math.min(...base),
              y: Math.min(...ys),
              width: Math.max(...base) - Math.min(...base),
              height: Math.max(...ys) - Math.min(...ys),
            };
            const nose = lm[1];
            const isCentered =
              nose.x > 0.3 && nose.x < 0.7 && nose.y > 0.3 && nose.y < 0.7;
            const dx = lm[263].x - lm[33].x,
              dy = lm[263].y - lm[33].y;
            const fw = Math.sqrt(dx * dx + dy * dy);
            const isDistGood = fw > 0.14 && fw < 0.4;
            const liris = lm[468],
              riris = lm[473];
              
            // Eye Aspect Ratio to check if eyes are open
            // Increased threshold to 0.24 to strictly ensure eyes are fully open
            const getDist = (p1, p2) => Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
            const leftWidth = getDist(lm[33], lm[133]);
            const leftHeight = getDist(lm[159], lm[145]);
            const rightWidth = getDist(lm[362], lm[263]);
            const rightHeight = getDist(lm[386], lm[374]);
            
            const leftEAR = leftWidth > 0 ? leftHeight / leftWidth : 0;
            const rightEAR = rightWidth > 0 ? rightHeight / rightWidth : 0;
            const areEyesOpen = leftEAR > 0.24 && rightEAR > 0.24;
            
            const lec = {
              x: (lm[33].x + lm[133].x) / 2,
              y: (lm[33].y + lm[133].y) / 2,
            };
            const rec = {
              x: (lm[362].x + lm[263].x) / 2,
              y: (lm[362].y + lm[263].y) / 2,
            };
            
            // Normalize iris displacement relative to eye width for scale invariance
            const leftIrisOffset = leftWidth > 0 ? Math.abs(liris.x - lec.x) / leftWidth : 1;
            const rightIrisOffset = rightWidth > 0 ? Math.abs(riris.x - rec.x) / rightWidth : 1;
            
            // Require iris offset to be small (looking straight)
            const isLookingAtCamera = leftIrisOffset < 0.15 && rightIrisOffset < 0.15;
            
            // Also check head rotation (yaw) by comparing horizontal distance from nose to eyes
            const distNoseToLeftEye = Math.abs(nose.x - lec.x);
            const distNoseToRightEye = Math.abs(nose.x - rec.x);
            // The ratio of these distances should be close to 1 if facing forward
            const headYawRatio = Math.min(distNoseToLeftEye, distNoseToRightEye) / Math.max(distNoseToLeftEye, distNoseToRightEye);
            const isHeadStraight = headYawRatio > 0.65; // Ensure head is not turned significantly
              
            const eyesOk = areEyesOpen && isLookingAtCamera && isHeadStraight;

            // Calculate Alignment Accuracy
            const centerX = 0.5,
              centerY = 0.5;
            const centerErr =
              Math.sqrt(
                Math.pow(nose.x - centerX, 2) + Math.pow(nose.y - centerY, 2),
              ) / 0.5; // Normalized 0-1
            const centeringScore = Math.max(0, 100 - centerErr * 100);

            const idealFw = 0.27;
            const distErr = Math.abs(fw - idealFw) / 0.13; // Normalized 0-1
            const distScore = Math.max(0, 100 - distErr * 100);

            const alignmentAccuracy = Math.round(
              centeringScore * 0.6 + distScore * 0.4,
            );

            // Eye Contact Accuracy
            const eyeErr =
              (Math.abs(liris.x - lec.x) + Math.abs(riris.x - rec.x)) / 0.1;
            const eyeAccuracy = Math.max(0, Math.round(100 - eyeErr * 100));

            let fs = "success",
              fm = "Perfect! Position is good",
              fi = "Center your face";
            if (!isCentered) {
              fs = "error";
              fm = "Face not centered";
              fi = "Center your face within the guide";
            } else if (!isDistGood) {
              fs = "error";
              fm = fw < 0.14 ? "Too far away" : "Too close";
              fi = fw < 0.14 ? "Move closer" : "Move further away";
            } else {
              fi = eyesOk ? "Ready to capture!" : (!areEyesOpen ? "Please open your eyes" : !isHeadStraight ? "Please face forward" : "Look directly at the camera");
            }
            
            let eyesMessage = "Look at the camera";
            if (eyesOk) {
              eyesMessage = "Eye contact detected";
            } else if (!areEyesOpen) {
              eyesMessage = "Eyes are closed";
            } else if (!isHeadStraight) {
              eyesMessage = "Please face forward";
            }
            
            const isAllValid = fs === "success" && eyesOk && aiChecks.lighting.status === "success";
            isValidPoseRef.current = isAllValid;
            
            setAiChecks((p) => ({
              ...p,
              face: {
                status: fs,
                message: fm,
                instruction: fi,
                accuracy: alignmentAccuracy,
              },
              eyes: {
                status: eyesOk ? "success" : "error",
                message: eyesMessage,
                accuracy: eyeAccuracy,
              },
            }));
            
            if (pendingFinalCheckRef.current) {
              pendingFinalCheckRef.current = false;
              if (!isAllValid) {
                setCapturedImage(null);
                toast.error("Capture aborted: Please maintain the correct pose at the exact moment of capture.");
              }
            } else if (
              isAllValid &&
              !isTimerRunningRef.current &&
              !capturedImage
            ) {
              stabilityCounterRef.current += 1;
              if (stabilityCounterRef.current >= 4) {
                takePicture();
                stabilityCounterRef.current = 0;
              }
            } else {
              stabilityCounterRef.current = 0;
            }
          } else {
            setAiChecks((p) => ({
              ...p,
              face: {
                status: "error",
                message: "Face not detected",
                instruction: "Position your face in front of the camera",
              },
              eyes: {
                status: "pending",
                message: "Waiting for face...",
                accuracy: 0,
              },
            }));
          }
        } catch (e) {}
      }
      animId = requestAnimationFrame(processFrame);
    };
    if (webcamStream && (!capturedImage || pendingFinalCheckRef.current))
      animId = requestAnimationFrame(processFrame);
    return () => {
      if (animId) cancelAnimationFrame(animId);
    };
  }, [webcamStream, capturedImage, aiChecks.lighting.status]);

  const capture = () => {
    if (webcamRef.current) setCapturedImage(webcamRef.current.getScreenshot());
  };
  const resetCapture = () => {
    setCapturedImage(null);
  };
  const savePicture = () => {
    setImageSrc(capturedImage);
    dispatch(setCandidateImage(capturedImage));
    setShowCameraDialog(false);
  };

  const takePicture = () => {
    setShowTimer(true);
    setIsTimerRunning(true);
    setTimer(3);
    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
    
    timerIntervalRef.current = setInterval(() => {
      setTimer((prev) => {
        if (!isValidPoseRef.current) {
          clearInterval(timerIntervalRef.current);
          setShowTimer(false);
          setIsTimerRunning(false);
          toast.error("Capture aborted: Please hold still and maintain correct pose.");
          return 3;
        }
        
        if (prev === 1) {
          clearInterval(timerIntervalRef.current);
          capture();
          pendingFinalCheckRef.current = true;
          setShowTimer(false);
          setIsTimerRunning(false);
          return 3;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleStartCamera = async () => {
    if (!cameraStarted) dispatch(startCamera());
  };
  const handleStopCamera = () => dispatch(stopCamera());
  const startScreenShare = async () => dispatch(askScreenShare());
  const handleStopScreenShare = () => {
    if (screenStream) dispatch(stopScreenShare(screenStream));
  };

  const handleEnterDetails = () => {
    if (hasSystemCheck) navigate("/check-system");
    else navigate("/enter-details");
  };

  const handlePrivacyCheck = (e) => {
    setPrivacyChecked(e.target.checked);
    setShowError((p) => ({ ...p, privacyChecked: !e.target.checked }));
  };

  const handleOpenStartDialog = () => {
    const errors = {
      screenShare: screenSetting?.active && !isScreenShared,
      camera: snapshotSetting?.active && !cameraStarted,
      image: snapshotSetting?.active && !imageSrc,
      privacyChecked: !privacyChecked,
    };
    if (
      errors.screenShare ||
      errors.camera ||
      errors.image ||
      errors.privacyChecked
    ) {
      setShowError(errors);
    } else {
      setShowStartDialog(true);
    }
  };

  const handleOverview = async () => {
    const fullScreenSetting = testSettings?.find(
      (s) => s.setting === "Turn on fullscreen while test",
    );
    if (fullScreenSetting?.active) enterFullScreen().catch(() => {});
    handleCandidate(testId);
    setShowStartDialog(false);
  };

  const handleProfileSnapshot = async (inviteId) => {
    try {
      if (candidateImage && !candidateImageStatus) {
        const snapshotData = candidateImage;
        const file = new File([snapshotData], "profile.jpg", {
          type: "image/jpeg",
        });
        const state = store.getState();
        const fileData = {
          requirement: [
            {
              order: 0,
              extension: file.name.substring(file.name.lastIndexOf(".") + 1),
            },
          ],
          module: `clientId/job_title_jobId/assessments/name_assessmentId/submission`,
          moduleType: "assessment_submission",
          clientId: state.testReducer.clientId,
          jobId: state.testReducer.jobId,
          assessmentId: testId,
          candidateId: inviteId,
          candidateName: state.candidateReducer.name,
          clientName: state.testReducer.company,
          assessmentName: state.testReducer.name,
        };
        await handleDynamicRequestHeader(
          "POST",
          `${BASE_URL}/public/file`,
          fileData,
          null,
          () => toast.error("Error uploading file"),
          async (fileResponse) => {
            const fileId = fileResponse.data[0].id,
              uploadURL = fileResponse.data[0].url;
            await handleDynamicRequestHeader(
              "POST",
              `${BASE_URL}/public/assessment/${testId}/upload-candidate-profile-picture?candidateAssessmentId=${inviteId}`,
              { profilePictureId: fileId },
              null,
              () => toast.error("Error uploading profile image"),
              async (data) => {
                if (data) {
                  const b64 = snapshotData.replace(
                    /^data:image\/(png|jpeg|jpg);base64,/,
                    "",
                  );
                  await axios.put(uploadURL, base64.toByteArray(b64), {
                    headers: { "Content-Type": "image/jpeg" },
                  });
                  dispatch(setCandidateImageStatus(true));
                }
              },
            );
          },
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  const setPreviousSelectedAnswers = (data) => {
    const ans = {};
    let total = data?.data?.totalTimeSpent || 0;
    data?.data?.skills?.forEach((skill) => {
      ["mcqQuestions", "programmingQuestions", "sqlQuestions"].forEach(
        (type) => {
          const qt = skill[type] || {};
          ["easyQuestions", "mediumQuestions", "hardQuestions"].forEach(
            (diff) => {
              (qt[diff] || []).forEach((q) => {
                if (q.isAnswered)
                  ans[q._id] = {
                    selectedAnswer: q.selectedAnswer || [],
                    isAnswered: true,
                    timeSpent: q.timeSpent || 0,
                  };
              });
            },
          );
        },
      );
    });
    dispatch(setPreviousSpentTime(total));
    dispatch(setAllSelectedAnswers(ans));
  };

  const getCombinedQuestions = async (uniqueId, candidateAssessmentId) => {
    setLoading(true);
    const list = [];
    const url = `${BASE_URL}/public/assessment/${uniqueId}/combine-questions?candidateAssessmentId=${candidateAssessmentId}`;
    await new Promise((resolve, reject) => {
      handleDynamicRequest(
        "GET",
        url,
        {},
        () => {
          toast.error("Error getting questions");
          setLoading(false);
          reject();
        },
        (data) => {
          if (data) {
            const fs = setting.find(
              (s) => s.setting === "Turn on fullscreen while test",
            );
            if (fs?.active) dispatch(setFullScreen(true));
            const shuffle = (arr) => {
              for (let i = arr.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [arr[i], arr[j]] = [arr[j], arr[i]];
              }
              return arr;
            };
            const shuffleSetting = setting?.find(
              (s) => s?.setting === "Shuffle question for each candidate",
            );
            data?.data?.skills?.forEach((skill) => {
              ["mcqQuestions", "programmingQuestions", "sqlQuestions"].forEach(
                (qt) => {
                  if (skill[qt]) {
                    ["easy", "medium", "hard"].forEach((d) => {
                      const qs = skill[qt][`${d}Questions`];
                      if (qs) {
                        if (shuffleSetting?.active)
                          skill[qt][`${d}Questions`] = shuffle(qs);
                        list.push(...qs);
                      }
                    });
                  }
                },
              );
            });

            // Sanitise: remove question-type keys that have zero questions across
            // all difficulty levels before storing in Redux. This prevents empty
            // shells like `sqlQuestions: { isRandom: false }` from reaching the
            // Overview page and causing NaN counts or rendering crashes.
            const QUESTION_TYPES = [
              "mcqQuestions",
              "programmingQuestions",
              "sqlQuestions",
            ];
            const DIFFICULTIES = ["easy", "medium", "hard"];

            const sanitisedSkills = data?.data?.skills?.map((skill) => {
              const sanitised = { ...skill };
              QUESTION_TYPES.forEach((qt) => {
                if (!(qt in sanitised)) return;
                const totalForType = DIFFICULTIES.reduce(
                  (sum, d) =>
                    sum + (sanitised[qt][`${d}Questions`]?.length ?? 0),
                  0,
                );
                if (totalForType === 0) delete sanitised[qt];
              });
              return sanitised;
            });

            dispatch(setTestData(sanitisedSkills));
            if (candidateRetake) {
              dispatch(setResumeDate(Date.now()));
              setPreviousSelectedAnswers(data);
            }
          }
          resolve();
        },
      );
    });
    setLoading(false);
    return list;
  };

  const handleCandidate = async (uniqueId) => {
    const body = {};
    if (candidateName) body.name = candidateName;
    if (candidateEmail) body.email = candidateEmail;
    if (candidateMobile) {
      const { countryCallingCode, nationalNumber } =
        parsePhoneNumber(candidateMobile);
      body.mobile = { countryCode: countryCallingCode, number: nationalNumber };
    }
    if (collegeName) body.collegeName = collegeName;
    if (Object.keys(candidateFields).length > 0)
      body.additionalFields = candidateFields;
    try {
      await handleDynamicRequestHeader(
        "POST",
        `${BASE_URL}/public/assessment/${uniqueId}/candidateFields`,
        body,
        null,
        () => {
          toast.error("Error creating candidate");
          setLoading(false);
        },
        async (data) => {
          if (data) {
            setLoading(false);
            const questions = await getCombinedQuestions(testId, data.data._id);
            if (questions?.length > 0) {
              dispatch(setInviteId(data.data._id));
              handleProfileSnapshot(data.data._id);
              document.body.classList.remove("modal-open");
              document.body.style.overflow = "auto";
              document.body.style.paddingRight = "0px";
              navigate("/overview", { replace: true });
              dispatch(setStartTime(Date.now()));
              dispatch(setCandidateMode(true));
            } else if (questions?.length === 0) {
              toast.error("No questions found");
            }
          }
        },
      );
    } catch (e) {
      toast.error("An unexpected error occurred");
      setLoading(false);
    }
  };

  // ── Prerequisite check for start dialog ──────────────────────────────────
  const canStart = () => {
    if (screenSetting?.active && !isScreenShared) return false;
    if (snapshotSetting?.active && !cameraStarted) return false;
    if (snapshotSetting?.active && !imageSrc) return false;
    if (!privacyChecked) return false;
    return true;
  };

  return (
    <>
      <ToastContainer />
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#f5f7fa",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* ── Unified Header ── */}
        <AssessmentHeader activeStep="Start Test" hasSystemCheck={hasSystemCheck} />

        {/* ── Main Content ── */}
        <Box
          sx={{
            flex: 1,
            py: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: { base: "95%", sm: "75%" }, mx: "auto" }}>
            {/* ── Card ── */}
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 2px 20px rgba(0,0,0,0.07)",
                overflow: "hidden",
              }}
            >
              {/* Card Header — Test Info */}
              <Box
                sx={{
                  padding: {
                    base: "14px 16px",
                    xss: "16px 20px",
                    sm: "20px 24px",
                  },
                  background: "linear-gradient(135deg, #fff 60%, #fff8f4 100%)",
                }}
              >
                <Stack
                  direction={{ base: "column", xss: "row" }}
                  alignItems={{ base: "flex-start", xss: "center" }}
                  justifyContent="space-between"
                  spacing={2}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "12px",
                        background: "linear-gradient(135deg, #FF6812, #ff9a5c)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        boxShadow: "0 3px 10px rgba(255,104,18,0.3)",
                      }}
                    >
                      <PlayCircleOutlineIcon
                        sx={{ fontSize: 24, color: "#fff" }}
                      />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: { base: "16px", xss: "17px", sm: "19px" },
                          fontWeight: 700,
                          color: "#1a1a2e",
                          lineHeight: 1.3,
                        }}
                      >
                        {testName}
                      </Typography>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={2}
                        mt={0.5}
                        flexWrap="wrap"
                      >
                        {testDate?.startsAt && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0.5}
                          >
                            <CalendarTodayOutlinedIcon
                              sx={{ fontSize: 13, color: "#000" }}
                            />
                            <Typography
                              sx={{ fontSize: "12px", color: "#000" }}
                            >
                              {testDate.startsAt} – {testDate.endsAt}
                            </Typography>
                          </Stack>
                        )}
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={0.5}
                        >
                          <AccessTimeOutlinedIcon
                            sx={{ fontSize: 13, color: "#000" }}
                          />
                          <Typography sx={{ fontSize: "12px", color: "#000" }}>
                            {testTime} hrs
                          </Typography>
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>
                </Stack>
              </Box>

              <Divider sx={{ borderColor: "#bdbdbd" }} />

              {/* ── Camera Section ── */}
              {snapshotSetting?.active && (
                <>
                  <Box sx={{ padding: { base: "16px", xss: "16px 24px" } }}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 700,
                        color: "#1a1a2e",
                        mb: 1.5,
                      }}
                    >
                      Proctoring Setup
                    </Typography>
                    <Stack
                      direction={{ base: "column", xl: "row" }}
                      spacing={2}
                    >
                      {/* Camera card */}
                      <Box
                        sx={{
                          flex: 1,
                          border: `1.5px solid ${showError.camera ? "#f44336" : cameraStarted ? "#4caf5040" : "#e0e0e0"}`,
                          borderRadius: "10px",
                          p: 2,
                          bgcolor: cameraStarted ? "#f0faf8" : "#fafafa",
                          transition: "all 0.2s",
                        }}
                      >
                        <Stack
                          direction={{ base: "column", xs: "row" }}
                          alignItems={{ base: "center", xs: "stretch" }}
                          spacing={2}
                        >
                          {/* Live webcam thumbnail */}
                          <Box
                            sx={{
                              width: 80,
                              height: 80,
                              borderRadius: "8px",
                              overflow: "hidden",
                              flexShrink: 0,
                              border: `2px solid ${cameraStarted ? "#4caf50" : "#e0e0e0"}`,
                              bgcolor: "#e0e0e0",
                            }}
                          >
                            {cameraStarted ? (
                              <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                videoConstraints={videoConstraints}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  display: "block",
                                  transform: "scaleX(-1)",
                                }}
                              />
                            ) : (
                              <img
                                src={userImage}
                                alt="Camera placeholder"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                          </Box>

                          {/* Info + button */}
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent={{
                                base: "center",
                                xs: "space-between",
                              }}
                              mb={0.5}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  color: "#1a1a2e",
                                  textAlign: { base: "center", xs: "left" },
                                }}
                              >
                                Why Camera?
                              </Typography>
                              {cameraStarted ? (
                                <CheckCircleIcon
                                  sx={{
                                    color: "#4caf50",
                                    fontSize: 20,
                                    display: { base: "none", xs: "block" },
                                  }}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: "50%",
                                    border: "2px solid #e0e0e0",
                                    display: { base: "none", xs: "block" },
                                  }}
                                />
                              )}
                            </Stack>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#666",
                                lineHeight: 1.5,
                                flex: 1,
                                textAlign: { base: "center", xs: "left" },
                              }}
                            >
                              Webcam required for proctoring. Snapshots every 30
                              secs.
                            </Typography>
                            <Box
                              sx={{
                                mt: 1,
                                display: "flex",
                                justifyContent: {
                                  base: "center",
                                  xs: "flex-start",
                                },
                              }}
                            >
                              {!cameraStarted ? (
                                <Button
                                  onClick={handleStartCamera}
                                  startIcon={<VideocamIcon />}
                                  size="small"
                                  sx={{
                                    bgcolor: "#FF6812",
                                    color: "#fff",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    height: "34px",
                                    px: 2,
                                    "&:hover": { bgcolor: "#e55a0f" },
                                  }}
                                >
                                  Start Camera
                                </Button>
                              ) : (
                                <Button
                                  onClick={handleStopCamera}
                                  startIcon={<VideocamOffIcon />}
                                  size="small"
                                  sx={{
                                    border: "1.5px solid #f44336",
                                    color: "#f44336",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    height: "34px",
                                    px: 2,
                                    "&:hover": { bgcolor: "#fff5f5" },
                                  }}
                                >
                                  Stop Camera
                                </Button>
                              )}
                              {showError.camera && (
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "#f44336",
                                    mt: 0.5,
                                  }}
                                >
                                  Camera is required to start the test
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Stack>
                      </Box>

                      {/* Profile picture card */}
                      <Box
                        sx={{
                          flex: 1,
                          border: `1.5px solid ${showError.image ? "#f44336" : imageSrc ? "#4caf5040" : "#e0e0e0"}`,
                          borderRadius: "10px",
                          p: 2,
                          bgcolor: imageSrc ? "#f0faf8" : "#fafafa",
                          transition: "all 0.2s",
                        }}
                      >
                        <Stack
                          direction={{ base: "column", xs: "row" }}
                          alignItems={{ base: "center", xs: "stretch" }}
                          spacing={2}
                        >
                          {/* Profile thumbnail */}
                          <Box
                            sx={{
                              width: 80,
                              height: 80,
                              borderRadius: "8px",
                              overflow: "hidden",
                              flexShrink: 0,
                              border: `2px solid ${imageSrc ? "#4caf50" : "#e0e0e0"}`,
                              bgcolor: "#e0e0e0",
                            }}
                          >
                            <img
                              src={imageSrc || dummyuserImage}
                              alt="Profile"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                          </Box>

                          {/* Info + button */}
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent={{
                                base: "center",
                                xs: "space-between",
                              }}
                              mb={0.5}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  color: "#1a1a2e",
                                  textAlign: { base: "center", xs: "left" },
                                }}
                              >
                                Profile Picture
                              </Typography>
                              {imageSrc ? (
                                <CheckCircleIcon
                                  sx={{
                                    color: "#4caf50",
                                    fontSize: 20,
                                    display: { base: "none", xs: "block" },
                                  }}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: "50%",
                                    border: "2px solid #e0e0e0",
                                    display: { base: "none", xs: "block" },
                                  }}
                                />
                              )}
                            </Stack>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#666",
                                lineHeight: 1.5,
                                flex: 1,
                                textAlign: { base: "center", xs: "left" },
                              }}
                            >
                              Used for identity verification throughout the
                              process.
                            </Typography>
                            <Box
                              sx={{
                                mt: 1,
                                display: "flex",
                                justifyContent: {
                                  base: "center",
                                  xs: "flex-start",
                                },
                              }}
                            >
                              <Button
                                onClick={() => {
                                  handleStartCamera();
                                  setShowCameraDialog(true);
                                }}
                                startIcon={<PanoramaIcon />}
                                size="small"
                                sx={{
                                  background: imageSrc
                                    ? "transparent"
                                    : "linear-gradient(135deg, #FF6812, #ff9a5c)",
                                  color: imageSrc ? "#FF6812" : "#fff",
                                  border: imageSrc
                                    ? "1.5px solid #FF6812"
                                    : "none",
                                  borderRadius: "8px",
                                  textTransform: "none",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  height: "34px",
                                  px: 2,
                                  boxShadow: imageSrc
                                    ? "none"
                                    : "0 2px 8px rgba(255,104,18,0.3)",
                                  "&:hover": {
                                    background: imageSrc
                                      ? "#fff4ee"
                                      : "linear-gradient(135deg, #e55a0f, #ff8533)",
                                    borderColor: imageSrc ? "#e55a0f" : "none",
                                  },
                                }}
                              >
                                {imageSrc ? "Retake Photo" : "Capture Photo"}
                              </Button>
                              {showError.image && (
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "#f44336",
                                    mt: 0.5,
                                  }}
                                >
                                  Profile picture is required
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </Stack>
                  </Box>
                  <Divider sx={{ borderColor: "#bdbdbd" }} />
                </>
              )}

              {/* ── Screen Share Section ── */}
              {screenSetting?.active && (
                <>
                  <Box sx={{ padding: { base: "16px", xss: "16px 24px" } }}>
                    <Box
                      sx={{
                        border: `1.5px solid ${showError.screenShare ? "#f44336" : isScreenShared ? "#4caf5040" : "#e0e0e0"}`,
                        borderRadius: "10px",
                        p: 2,
                        bgcolor: isScreenShared ? "#f0faf8" : "#fafafa",
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1.5}
                        mb={1}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "8px",
                            bgcolor: isScreenShared ? "#e8f5e9" : "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <ScreenShareOutlinedIcon
                            sx={{
                              fontSize: 18,
                              color: isScreenShared ? "#4caf50" : "#aaa",
                            }}
                          />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 700,
                              color: "#1a1a2e",
                            }}
                          >
                            Screen Sharing
                          </Typography>
                          <Typography sx={{ fontSize: "12px", color: "#888" }}>
                            Your entire screen must be shared for proctoring.
                            Tab/window sharing will result in disqualification.
                          </Typography>
                        </Box>
                        {isScreenShared ? (
                          <CheckCircleIcon
                            sx={{ color: "#4caf50", fontSize: 20 }}
                          />
                        ) : (
                          <Box
                            sx={{
                              width: 20,
                              height: 20,
                              borderRadius: "50%",
                              border: "2px solid #e0e0e0",
                            }}
                          />
                        )}
                      </Stack>
                      {!isScreenShared ? (
                        <Button
                          onClick={startScreenShare}
                          startIcon={<PresentToAllIcon />}
                          size="small"
                          sx={{
                            bgcolor: "#FF6812",
                            color: "#fff",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontSize: "12px",
                            fontWeight: 600,
                            height: "36px",
                            "&:hover": { bgcolor: "#e55a0f" },
                          }}
                        >
                          Start Screen Share
                        </Button>
                      ) : (
                        <Button
                          onClick={handleStopScreenShare}
                          startIcon={<CancelPresentationIcon />}
                          size="small"
                          sx={{
                            border: "1px solid #f44336",
                            color: "#f44336",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontSize: "12px",
                            fontWeight: 600,
                            height: "36px",
                            "&:hover": { bgcolor: "#fff5f5" },
                          }}
                        >
                          Stop Screen Share
                        </Button>
                      )}
                      {showError.screenShare && (
                        <Typography
                          sx={{ fontSize: "11px", color: "#f44336", mt: 0.5 }}
                        >
                          Screen sharing is required to start the test
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Divider sx={{ borderColor: "#bdbdbd" }} />
                </>
              )}

              {/* ── Instructions Section ── */}
              <Box sx={{ padding: { base: "16px", xss: "16px 24px" } }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1.5}>
                  <Typography
                    sx={{ fontSize: "16px", fontWeight: 700, color: "#1a1a2e" }}
                  >
                    Test Instructions
                  </Typography>
                </Stack>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "6px" }}
                >
                  {testInstructions?.map((instr, i) => (
                    <Stack
                      key={i}
                      direction="row"
                      alignItems="flex-start"
                      spacing={1.5}
                    >
                      <Box
                        sx={{
                          mt: "3px",
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          bgcolor: "#fff3ec",
                          border: "1.5px solid #FF6812",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "10px",
                            fontWeight: 700,
                            color: "#FF6812",
                            lineHeight: 1,
                          }}
                        >
                          {i + 1}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          color: "#555",
                          lineHeight: 1.7,
                        }}
                      >
                        {instr}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              </Box>

              <Divider sx={{ borderColor: "#bdbdbd" }} />

              {/* ── Privacy + Actions ── */}
              <Box sx={{ padding: { base: "16px", xss: "16px 24px" } }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ mb: 0.5 }}
                >
                  <Checkbox
                    checked={privacyChecked}
                    onChange={handlePrivacyCheck}
                    sx={{
                      color: showError.privacyChecked ? "#f44336" : "#FF6812",
                      "&.Mui-checked": { color: "#FF6812" },
                      p: 0.5,
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: showError.privacyChecked ? "#f44336" : "#555",
                    }}
                  >
                    I agree to the privacy policy and terms of use of
                    HireCorrecto
                  </Typography>
                </Stack>
                {showError.privacyChecked && (
                  <Typography
                    sx={{ fontSize: "11px", color: "#f44336", ml: 4.5, mb: 1 }}
                  >
                    Please accept the terms to continue
                  </Typography>
                )}
              </Box>

              <Divider sx={{ borderColor: "#bdbdbd" }} />

              {/* Footer Buttons */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { base: "column-reverse", xss: "row" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: { base: "16px", xss: "24px" },
                  py: "16px",
                  gap: { base: 1.5, xss: 2 },
                }}
              >
                <Button
                  onClick={handleEnterDetails}
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    height: 40,
                    border: "1.5px solid #e0e0e0",
                    color: "#555",
                    fontSize: "13px",
                    fontWeight: 600,
                    textTransform: "none",
                    borderRadius: "10px",
                    width: { base: "100%", xss: "auto" },
                    px: 3,
                    "&:hover": {
                      borderColor: "#FF6812",
                      color: "#FF6812",
                      bgcolor: "#fff8f4",
                    },
                    transition: "all 0.2s",
                  }}
                >
                  Back
                </Button>
                <Button
                  onClick={handleOpenStartDialog}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    background: "linear-gradient(135deg, #00c49a, #00e6b4)",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: { base: "14px", xss: "15px" },
                    height: 42,
                    borderRadius: "10px",
                    textTransform: "none",
                    boxShadow: "0 4px 16px rgba(0,196,154,0.35)",
                    width: { base: "100%", xss: "auto" },
                    px: { xss: 4 },
                    "&:hover": {
                      background: "linear-gradient(135deg, #00a882, #00c49a)",
                      boxShadow: "0 6px 20px rgba(0,196,154,0.45)",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.2s ease",
                  }}
                >
                  Start Test
                </Button>
              </Box>
            </Box>

            {/* Footer */}
            <Box
              sx={{ mt: 4, mb: 2, display: "flex", justifyContent: "center" }}
            >
              <img
                src={WhoWeAreImgpowerd}
                alt="Powered by HireCorrecto"
                style={{ height: 28, width: 200 }}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ── Camera Capture Dialog ── */}
      <Dialog
        open={showCameraDialog}
        onClose={() => !isTimerRunning && setShowCameraDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1,
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "8px",
                bgcolor: "#fff3ec",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PanoramaIcon sx={{ fontSize: 18, color: "#FF6812" }} />
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: "15px", fontWeight: 700, color: "#1a1a2e" }}
              >
                Capture Profile Picture
              </Typography>
              <Typography sx={{ fontSize: "12px", color: "#888" }}>
                Ensure your face is clearly visible against a plain background
              </Typography>
            </Box>
          </Stack>
          {!isTimerRunning && (
            <IconButton
              onClick={() => setShowCameraDialog(false)}
              size="small"
              sx={{ color: "#888" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Stack
            direction={{ base: "column", sm: "row" }}
            spacing={{ base: 2, sm: 2 }}
            alignItems="stretch"
            mt={2}
          >
            {/* ── LEFT: Live webcam + AI checks ── */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: { base: 2, sm: 1.5 },
              }}
            >
              {cameraStarted && (
                <>
                  {/* Webcam feed */}
                  <Box
                    sx={{
                      position: "relative",
                      borderRadius: "10px",
                      overflow: "hidden",
                      height: { base: 220, xs: 240, sm: 300 },
                      bgcolor: "#000",
                      flexShrink: 0,
                    }}
                  >
                    <Webcam
                      audio={false}
                      mirrored
                      className="uploadProfile"
                      screenshotFormat="image/jpeg"
                      screenshotQuality={1}
                      forceScreenshotSourceSize={true}
                      videoConstraints={videoConstraints}
                      ref={webcamRef}
                      width="100%"
                      height="100%"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        display: "block",
                        minHeight: "100%",
                        minWidth: "100%",
                      }}
                    />
                    <PoseOverlay
                      status={capturedImage ? "success" : aiChecks.face.status}
                      instruction={
                        capturedImage
                          ? "Image captured successfully!"
                          : aiChecks.face.instruction
                      }
                    />
                    {ShowTimer && (
                      <Box
                        sx={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          bgcolor: "rgba(0,0,0,0.4)",
                          borderRadius: "10px",
                        }}
                      >
                        <Typography
                          sx={{ fontSize: 64, fontWeight: 900, color: "#fff" }}
                        >
                          {timer}
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* AI status chips */}
                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                    {[
                      {
                        icon: <LightModeIcon sx={{ fontSize: 13 }} />,
                        label: `${aiChecks.lighting.message} (${aiChecks.lighting.accuracy}%)`,
                        status: aiChecks.lighting.status,
                      },
                      {
                        icon: <FaceIcon sx={{ fontSize: 13 }} />,
                        label: `${aiChecks.face.message} (${aiChecks.face.accuracy}%)`,
                        status: aiChecks.face.status,
                      },
                      {
                        icon: <VideocamIcon sx={{ fontSize: 13 }} />,
                        label: `${aiChecks.eyes.message} (${aiChecks.eyes.accuracy}%)`,
                        status: aiChecks.eyes.status,
                      },
                    ].map((item, i) => {
                      const isSuccess = item.status === "success";
                      const isError = item.status === "error";
                      return (
                        <Chip
                          key={i}
                          icon={React.cloneElement(item.icon, {
                            sx: {
                              fontSize: 13,
                              color: isSuccess
                                ? "#2e7d32 !important"
                                : isError
                                  ? "#c62828 !important"
                                  : "#e65100 !important",
                            },
                          })}
                          label={item.label}
                          size="small"
                          sx={{
                            bgcolor: isSuccess
                              ? "#e8f5e9"
                              : isError
                                ? "#ffebee"
                                : "#fff3e0",
                            color: isSuccess
                              ? "#2e7d32"
                              : isError
                                ? "#c62828"
                                : "#e65100",
                            fontWeight: 600,
                            fontSize: "11px",
                            border: `1px solid ${isSuccess ? "#a5d6a7" : isError ? "#ef9a9a" : "#ffcc80"}`,
                          }}
                        />
                      );
                    })}
                  </Stack>
                </>
              )}
            </Box>

            {/* ── RIGHT: Preview ── */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: { base: 2, sm: 1 },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: { base: 220, xs: 240, sm: 300 },
                  borderRadius: "10px",
                  overflow: "hidden",
                  border: `1.5px solid ${capturedImage ? "#4caf50" : "#e0e0e0"}`,
                  bgcolor: "#fafafa",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  transition: "border-color 0.3s",
                }}
              >
                <img
                  src={capturedImage || uploadProfile}
                  alt="Preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    filter: isTimerRunning ? "blur(4px)" : "none",
                    transition: "filter 0.3s",
                  }}
                />
              </Box>
              {capturedImage ? (
                <Chip
                  label="Photo captured ✓"
                  size="small"
                  sx={{
                    bgcolor: "#e8f5e9",
                    color: "#4caf50",
                    fontWeight: 700,
                    fontSize: "11px",
                  }}
                />
              ) : (
                <Typography sx={{ fontSize: "11px", color: "#7a7b7d" }}>
                  Preview will appear here after capture
                </Typography>
              )}
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            padding: "10px 20px",
            borderTop: "1px solid #f0f0f0",
            justifyContent: "space-between",
          }}
        >
          <Box />
          <Stack direction="row" spacing={1.5}>
            {!isTimerRunning && (
              <Tooltip
                title={
                  !capturedImage &&
                  (aiChecks.face.status === "error" ||
                    aiChecks.eyes.status === "error")
                    ? "Fix face position to capture"
                    : ""
                }
                arrow
              >
                <span>
                  <Button
                    onClick={capturedImage ? resetCapture : takePicture}
                    disabled={
                      !capturedImage &&
                      (aiChecks.lighting.status !== "success" ||
                        aiChecks.face.status !== "success" ||
                        aiChecks.eyes.status !== "success")
                    }
                    sx={{
                      bgcolor: capturedImage
                        ? "#bdbdbd"
                        : aiChecks.lighting.status === "success" &&
                            aiChecks.face.status === "success" &&
                            aiChecks.eyes.status === "success"
                          ? "#4caf50"
                          : "#FF6812",
                      color: capturedImage ? "#555" : "#fff",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "13px",
                      height: "40px",
                      "&:hover": {
                        bgcolor: capturedImage
                          ? "#a5a5a1"
                          : aiChecks.lighting.status === "success" &&
                              aiChecks.face.status === "success" &&
                              aiChecks.eyes.status === "success"
                            ? "#388e3c"
                            : "#e65100",
                        opacity: 1,
                      },
                      "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" },
                    }}
                    startIcon={
                      !capturedImage &&
                      aiChecks.face.status === "success" &&
                      aiChecks.eyes.status === "success" ? (
                        <CheckCircleIcon />
                      ) : null
                    }
                  >
                    {capturedImage ? "Retake" : "Capture"}
                  </Button>
                </span>
              </Tooltip>
            )}
            {capturedImage && !isTimerRunning && (
              <Button
                onClick={savePicture}
                disabled={
                  aiChecks.lighting.status !== "success" ||
                  aiChecks.face.status !== "success" ||
                  aiChecks.eyes.status !== "success"
                }
                sx={{
                  bgcolor: "#4caf50",
                  color: "#fff",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "13px",
                  height: "40px",
                  "&:hover": { bgcolor: "#388e3c" },
                  "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" },
                }}
              >
                Save Photo
              </Button>
            )}
          </Stack>
        </DialogActions>
      </Dialog>

      {/* ── Start Test Confirmation Dialog ── */}
      <Dialog
        open={showStartDialog}
        onClose={() => setShowStartDialog(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px" } }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #f0f0f0",
            px: { base: 2, xs: 3 },
            py: 2,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "10px",
                background: "linear-gradient(135deg, #FF6812, #ff9a5c)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 2px 8px rgba(255,104,18,0.25)",
              }}
            >
              <PlayCircleOutlineIcon sx={{ fontSize: 20, color: "#fff" }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: { base: "16px", xs: "17px" },
                  fontWeight: 700,
                  color: "#1a1a2e",
                  lineHeight: 1.2,
                }}
              >
                Ready to Start?
              </Typography>
              <Typography sx={{ fontSize: "12px", color: "#666", mt: 0.3 }}>
                Confirm all prerequisites below
              </Typography>
            </Box>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ p: { base: 2, xs: 3 }, mt: 2 }}>
          <Stack spacing={1.5}>
            {screenSetting?.active && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                sx={{
                  p: 1,
                  borderRadius: "8px",
                  bgcolor: isScreenShared ? "#f0faf8" : "#fff5f5",
                  border: `1px solid ${isScreenShared ? "#b2dfdb" : "#ffcdd2"}`,
                }}
              >
                <Checkbox
                  checked={isScreenShared}
                  onChange={(e) => {
                    e.preventDefault();
                    isScreenShared
                      ? handleStopScreenShare()
                      : startScreenShare();
                  }}
                  sx={{
                    color: "#FF6812",
                    "&.Mui-checked": { color: "#4caf50" },
                    p: 0,
                  }}
                />
                <Typography sx={{ fontSize: "13px", color: "#333", flex: 1 }}>
                  Screen Sharing Active
                </Typography>
                {isScreenShared ? (
                  <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 18 }} />
                ) : (
                  <ErrorIcon sx={{ color: "#f44336", fontSize: 18 }} />
                )}
              </Stack>
            )}
            {snapshotSetting?.active && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                sx={{
                  p: 1.5,
                  borderRadius: "8px",
                  bgcolor: cameraStarted ? "#f0faf8" : "#fff5f5",
                  border: `1px solid ${cameraStarted ? "#b2dfdb" : "#ffcdd2"}`,
                }}
              >
                <Checkbox
                  checked={cameraStarted}
                  onChange={(e) => {
                    e.preventDefault();
                    cameraStarted ? handleStopCamera() : handleStartCamera();
                  }}
                  sx={{
                    color: "#FF6812",
                    "&.Mui-checked": { color: "#4caf50" },
                    p: 0,
                  }}
                />
                <Typography sx={{ fontSize: "13px", color: "#333", flex: 1 }}>
                  Camera Active
                </Typography>
                {cameraStarted ? (
                  <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 18 }} />
                ) : (
                  <ErrorIcon sx={{ color: "#f44336", fontSize: 18 }} />
                )}
              </Stack>
            )}
            {multiScreenSetting?.active && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                sx={{
                  p: 1.5,
                  borderRadius: "8px",
                  bgcolor: "#fafafa",
                  border: "1px solid #e0e0e0",
                }}
              >
                <Checkbox
                  checked={multiScreenChecked}
                  onChange={() => setMultiScreenChecked((p) => !p)}
                  sx={{
                    color: "#FF6812",
                    "&.Mui-checked": { color: "#4caf50" },
                    p: 0,
                  }}
                />
                <Typography sx={{ fontSize: "13px", color: "#333", flex: 1 }}>
                  Multi Screen Check
                </Typography>
              </Stack>
            )}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{
                p: 1.5,
                borderRadius: "8px",
                bgcolor: privacyChecked ? "#f0faf8" : "#fff5f5",
                border: `1px solid ${privacyChecked ? "#b2dfdb" : "#ffcdd2"}`,
              }}
            >
              <Checkbox
                checked={privacyChecked}
                onChange={handlePrivacyCheck}
                sx={{
                  color: "#FF6812",
                  "&.Mui-checked": { color: "#4caf50" },
                  p: 0,
                }}
              />
              <Typography sx={{ fontSize: "14px", color: "#333", flex: 1 }}>
                I agree to Terms & Conditions
              </Typography>
              {privacyChecked ? (
                <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 18 }} />
              ) : (
                <ErrorIcon sx={{ color: "#f44336", fontSize: 18 }} />
              )}
            </Stack>
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            px: { base: 2, xs: 3 },
            py: 2,
            borderTop: "1px solid #f0f0f0",
            flexDirection: { base: "column-reverse", xs: "row" },
            gap: 1.5,
          }}
        >
          <Button
            onClick={() => setShowStartDialog(false)}
            sx={{
              color: "#666",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "14px",
              width: { base: "100%", xs: "auto" },
              height: 40,
              "&:hover": { bgcolor: "#f5f5f5" },
            }}
          >
            Cancel
          </Button>
          <Tooltip
            title={!canStart() ? "Please complete all prerequisites" : ""}
            arrow
            placement="top"
          >
            <Box sx={{ width: { base: "100%", xs: "auto" } }}>
              <Button
                onClick={handleOverview}
                disabled={loading || !canStart()}
                fullWidth
                endIcon={
                  loading ? (
                    <CircularProgress size={14} color="inherit" />
                  ) : (
                    <ArrowForwardIcon />
                  )
                }
                sx={{
                  background: "linear-gradient(135deg, #00c49a, #00e6b4)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: { base: "14px", xs: "15px" },
                  height: 42,
                  borderRadius: "10px",
                  textTransform: "none",
                  px: 4,
                  boxShadow: "0 4px 12px rgba(0,196,154,0.3)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #00a882, #00c49a)",
                    boxShadow: "0 6px 16px rgba(0,196,154,0.4)",
                    transform: "translateY(-1px)",
                  },
                  "&.Mui-disabled": {
                    background: "#e0e0e0",
                    color: "#aaa",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                {loading ? "Starting…" : "Start Test"}
              </Button>
            </Box>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default StartTest;
